var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculatorRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83335 1.66699H14.1667C14.6087 1.66699 15.0326 1.84259 15.3452 2.15515C15.6578 2.46771 15.8334 2.89163 15.8334 3.33366V16.667C15.8334 17.109 15.6578 17.5329 15.3452 17.8455C15.0326 18.1581 14.6087 18.3337 14.1667 18.3337H5.83335C5.39133 18.3337 4.9674 18.1581 4.65484 17.8455C4.34228 17.5329 4.16669 17.109 4.16669 16.667V3.33366C4.16669 2.89163 4.34228 2.46771 4.65484 2.15515C4.9674 1.84259 5.39133 1.66699 5.83335 1.66699ZM5.83335 3.33366V6.66699H14.1667V3.33366H5.83335ZM5.83335 8.33366V10.0003H7.50002V8.33366H5.83335ZM9.16669 8.33366V10.0003H10.8334V8.33366H9.16669ZM12.5 8.33366V10.0003H14.1667V8.33366H12.5ZM5.83335 11.667V13.3337H7.50002V11.667H5.83335ZM9.16669 11.667V13.3337H10.8334V11.667H9.16669ZM12.5 11.667V13.3337H14.1667V11.667H12.5ZM5.83335 15.0003V16.667H7.50002V15.0003H5.83335ZM9.16669 15.0003V16.667H10.8334V15.0003H9.16669ZM12.5 15.0003V16.667H14.1667V15.0003H12.5Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorRedIcon);
export default __webpack_public_path__ + "static/media/calculator-red-icon.3a191c8e2a0e4fb1760162da972d8943.svg";
export { ForwardRef as ReactComponent };